import { maLocalStorage } from '@/lib/storage'
import { envSchema } from './schema'

// @ts-expect-error - MaNotification types not available
import { MaNotification } from '@mobileaction/action-kit'

// eslint-disable-next-line no-restricted-syntax
export const originalEnv = envSchema.cast(import.meta.env)

const isProduction = originalEnv.VITE_APP_HEROKU_ENV === 'production'

const customVars = !isProduction ? (maLocalStorage.customEnvVariables || {}) : {}
export const maEnv = { ...originalEnv, ...customVars }

export { isProduction }
export const isStaging = maEnv.VITE_APP_HEROKU_ENV === 'staging'
export const isDevelopment = maEnv.VITE_APP_HEROKU_ENV === 'development'

// Show emergency reset notification if custom variables exist (non-production only)
if (!isProduction && Object.keys(customVars).length > 0) {
  MaNotification.info({
    variant: 'stroke',
    type: 'info',
    title: ' Environment Variables Override Active',
    description: 'Custom environment variables are currently overriding default values. If you\'re experiencing issues (like API errors), you can clear all overrides and refresh the page.',
    duration: 10000,
    buttons: [
      {
        label: 'Clear All & Refresh',
        onClick: () => {
          maLocalStorage.customEnvVariables = {}
          window.location.reload()
        },
      },
    ],
  })
}
